import { TableRows } from '@mui/icons-material';
import { Chip, SxProps } from '@mui/material';
import { ReactElement } from 'react';

type PropsType = {
  count: number;
  icon?: ReactElement;
  description?: string;
  sx?: SxProps;
};

export const ReportDatasetRowCount = (props: PropsType) => {
  const { count, icon, description, sx } = props;

  return (
    <Chip
      icon={icon ?? <TableRows />}
      label={description ? `${description}: ${count}` : count}
      sx={sx}
    />
  );
};
